import React from 'react';

// The way to pay as the app's (MerxandatgeChoiceButtons): cards side by side, each
// with its icon, the chosen one outlined in the colla's colour. Card first, as there.
const ORDER = ['Targeta', 'Transferència', 'En persona'];

const ICONS = {
  Targeta: (
    <>
      <rect x="2.5" y="5" width="19" height="14" rx="2" />
      <path d="M2.5 9.5h19M6 15h4" />
    </>
  ),
  Transferència: (
    <path d="M3 9.5 12 4l9 5.5M4.5 10v8M9.5 10v8M14.5 10v8M19.5 10v8M3 20h18" />
  ),
  'En persona': (
    <>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" />
    </>
  ),
};

const PaymentMethodCards = ({ name, options, value, disabled, onChange }) => {
  const sorted = [...options].sort((a, b) => {
    const rank = (option) => (ORDER.includes(option.label) ? ORDER.indexOf(option.label) : ORDER.length);
    return rank(a) - rank(b);
  });
  return (
    <div className="payment-method-cards" role="radiogroup" aria-label="Mètode de pagament">
      {sorted.map(({ label, index }) => {
        const checked = value === index;
        return (
          <label key={index} className={`payment-method-card${checked ? ' selected' : ''}${disabled ? ' disabled' : ''}`}>
            <input
              type="radio"
              name={name}
              checked={checked}
              onChange={() => (disabled ? undefined : onChange(index))}
              disabled={disabled}
            />
            {ICONS[label] ? (
              <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
                {ICONS[label]}
              </svg>
            ) : null}
            <span>{label}</span>
          </label>
        );
      })}
    </div>
  );
};

export default PaymentMethodCards;
